import _ from 'underscore';

angular.module('gym.contacts').directive('editContactRelationship', function() {
  return {
    restrict: 'E',
    template: require('templates/gyms/contacts/edit_relationship.html.slim'),
    scope: {
      contact: '=',
      params: '=',
      forms: '=',
      close: '&',
      reloadRelationships: '&'
    },
    controller: ["$scope", "$rootScope", "$document", "flash", "Contacts", function($scope, $rootScope, $document, flash, Contacts) {
      var contact, saveRelationship;
      $scope.gym = $rootScope.gym;
      contact = $scope.contact;
      $scope.form = _.find($scope.forms, {
        name: 'contact_relationships'
      });
      $scope.relationship = _.find(contact.contact_relationships, function(relationship) {
        return relationship.id === $scope.params.id;
      }) || {};
      $scope.relationship_types = contact.relationship_types;
      $scope.getContacts = function(text) {
        return Contacts.getList({
          all_contacts_search: text,
          exclude_contact_id: contact.id
        });
      };
      $scope.onContactSelect = function(contact) {
        $scope.selectedContact = contact;
        return $scope.relationship.related_contact_id = contact.id;
      };
      $scope.restoreName = function() {
        if ($scope.relationship.errors) {
          $scope.relationship.errors.contact_id = void 0;
        }
        return $scope.relationship.related_contact_name = $scope.selectedContact ? $scope.selectedContact.name : '';
      };
      $scope.isFormValid = function() {
        return $scope.relationship.related_contact_id && $scope.relationship.relationship_type;
      };
      saveRelationship = function() {
        $scope.relationship.rootObjectName = 'contact_relationship';
        $scope.relationship.contact_id = contact.id;
        if ($scope.relationship.id) {
          return contact.one('contact_relationships', $scope.relationship.id).doPUT($scope.relationship);
        } else {
          return contact.all('contact_relationships').doPOST($scope.relationship);
        }
      };
      return $scope.save = function() {
        $scope.isLoading = true;
        return saveRelationship().then(function() {
          flash.success = 'Relationship saved successfully';
          $scope.reloadRelationships();
          return $scope.close();
        }, function(response) {
          $scope.relationship.errors = response.data.errors;
          flash.error = 'Save failed. Please fix the errors below';
          return $scope.isLoading = false;
        });
      };
    }]
  };
});
